
import React from 'react';
import { CreditCard, Bitcoin } from 'lucide-react';

export type VerificationMethod = 'card' | 'bitcoin';

interface VerificationMethodSelectorProps {
  selectedMethod: VerificationMethod;
  onMethodChange: (method: VerificationMethod) => void;
}

const VerificationMethodSelector: React.FC<VerificationMethodSelectorProps> = ({
  selectedMethod,
  onMethodChange
}) => {
  return (
    <div className="flex justify-center space-x-4 mb-6">
      <button
        type="button"
        onClick={() => onMethodChange('card')}
        className={`flex flex-col items-center p-3 rounded-lg transition-all ${
          selectedMethod === 'card'
            ? 'bg-blue-100 text-blue-700 border-2 border-blue-500'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        <CreditCard className="h-6 w-6 mb-1" />
        <span className="text-xs font-medium">Credit Card</span>
      </button>
      
      <button
        type="button"
        onClick={() => onMethodChange('bitcoin')}
        className={`flex flex-col items-center p-3 rounded-lg transition-all ${
          selectedMethod === 'bitcoin'
            ? 'bg-amber-100 text-amber-700 border-2 border-amber-500'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
        }`}
      >
        <Bitcoin className="h-6 w-6 mb-1" />
        <span className="text-xs font-medium">Bitcoin</span>
      </button>
    </div>
  );
};

export default VerificationMethodSelector;
